import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-950"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-40"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Epic%20anime%20manga%20illustration%20with%20dynamic%20action%20scene%2C%20warm%20orange%20and%20coral%20color%20palette%2C%20Japanese%20manga%20style%20background%20with%20speed%20lines%20and%20energy%20effects%2C%20vibrant%20warm%20lighting%2C%20cinematic%20composition%2C%20rich%20textures%2C%20dramatic%20atmosphere&width=1600&height=900&seq=hero-bg-manga-2026&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/80"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-sm font-medium text-primary-300 whitespace-nowrap">海量资源 · 免费畅读 · 日更不停</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
              汗汗漫画
              <span className="block text-primary-400 text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-2">
                漫画全集免费阅读平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-300 font-medium mb-2">
              全集免费阅读，一次看过瘾
            </p>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              汗汗漫画🎯汇聚全网漫画全集免费漫画大全资源，无论是热血战斗、玄幻修真还是恋爱甜宠，这里应有尽有。🎉
              支持全集免费阅读，无需注册付费，每日同步更新数百话热门漫画，让你随时随地沉浸在漫画世界中。
              在线看漫画海量免费内容随时追更，轻松收藏，一次看个过瘾！
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-400 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line mr-2"></i>
                开始阅读
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 border border-background-300/40 hover:border-primary-400/60 text-background-200 hover:text-primary-300 font-semibold rounded-lg transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bar-chart-line mr-2"></i>
                查看热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg mx-auto">
            <div className="relative">
              <div className="absolute -inset-2 bg-primary-500/20 rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20manga%20reader%20illustration%20with%20floating%20comic%20pages%20and%20colorful%20action%20scenes%2C%20warm%20orange%20and%20coral%20color%20palette%2C%20magical%20reading%20atmosphere%2C%20anime%20art%20style%2C%20vibrant%20energy%20effects%2C%20clean%20composition%2C%20high%20quality%20digital%20art%2C%20professional%20illustration&width=700&height=900&seq=hero-visual-manga-2026&orientation=portrait"
                alt="汗汗漫画 - 漫画全集免费阅读平台主视觉"
                className="relative rounded-xl w-full h-auto object-cover shadow-2xl"
                style={{ maxHeight: '480px' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}